<template>
  <v-layout :title="$t('insurancerefundrecipe.content_title')">
    <template slot="navigation">
      <InsuranceRefundNavigation />
    </template>
    <template slot="logo" v-if="logo_url">
      <b-img :src="logo_url" class="mw-100" />
    </template>
    <InsuranceRefundInvoice v-on:recipe:done="onRecipeDone" />
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default";
import InsuranceRefundNavigation from "@/components/insurancerefund/InsuranceRefundNavigation";
import InsuranceRefundInvoice from "@/components/insurancerefund/InsuranceRefundInvoice";
import { mapGetters } from "vuex";

export default {
  name: "insurancerefund-invoice-view",
  data() {
    return {
      logo_url: undefined,
    };
  },
  computed: {
    ...mapGetters("organization", ["getInsuranceDataByUUID"]),
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    putLogo(organization) {
      if (
        organization &&
        organization.configuration &&
        organization.configuration.show_form_logo
      ) {
        this.logo_url = organization.configuration.form_logo;
      }
    },
    putBreadCrumb(organization) {
      this.$store.commit("siteconf/MUTATE_BREADCRUMB", [
        {
          langkey: "breadcrumb.home",
          to: { name: "home" },
        },
        {
          langkey: "breadcrumb.refund_insurance_selection",
          to: { name: "nopatient_insurancerefund_insurance_selection" },
        },
        {
          langkey: "breadcrumb.insurancerefund_home",
          langparams: {
            insurance_name: (organization || {}).public_name || "Insurance",
          },
          to: { name: "nopatient_insurancerefund_home" },
        },
        {
          langkey: "breadcrumb.refund_recipe",
          to: { name: "nopatient_insurancerefund_invoice" },
        },
      ]);
    },
    loadData() {
      var organization = this.getInsuranceDataByUUID(this.$route.params.i_uuid);
      if (!organization) {
        this.$store.dispatch("organization/INSURANCE_REFUND_LIST").then(
          () => {
            organization = this.getInsuranceDataByUUID(
              this.$route.params.i_uuid
            );
            this.putBreadCrumb(organization);
            this.putLogo(organization);
          },
          (err) => {
            throw new Error(err);
            //this.consoleout(err);
          }
        );
      } else {
        this.putBreadCrumb(organization);
        this.putLogo(organization);
      }
    },
    onRecipeDone: function () {
      this.$router.push({
        name: "nopatient_insurancerefund_home",
        params: {
          pt_uuid: this.$route.params.pt_uuid,
          i_uuid: this.$route.params.i_uuid,
          insurancerefund_uuid: this.$route.params.insurancerefund_uuid,
        },
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        insurancerefundrecipe: {
          content_title: "Insurance recipe",
        },
      },
    },
  },
  components: {
    VLayout,
    InsuranceRefundInvoice,
    InsuranceRefundNavigation,
  },
};
</script>

<style>
</style>
